export default __webpack_public_path__ + "static/media/Landing.cf2f54a5.png";